import React from "react";
import "./ButtonNext.scss";
import { Button } from "@evidenceb/athena-common/design-system/Button";
import classNames from "classnames";

interface Props {
    onClick: () => void;
    label: string;
    className?: string;
}
const ButtonNext = ({ onClick, label, className }: Props) => {
    return (
        <Button
            className={classNames("subject-choice__button-next", className)}
            label={label}
            variant="custom"
            colors={{
                background: "var(--element-evidenceb-default)",
                text: "var(--default-black)",
                hoverBackground: "var(--text-main-default)",
                hoverText: "var(--default-black)",
            }}
            onPress={onClick}
        />
    );
};

export default ButtonNext;
